/* import __COLOCATED_TEMPLATE__ from './tours-messenger-not-loaded.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();